WatchSumo.WeeklyResponseTimes = class WeeklyResponseTimes extends WatchSumo.Graph {
  render() {
    return Morris.Line({
      element: this.element,
      data: this.data,
      xkey: 'date',
      ykeys: ['average'],
      labels: ['Mean Response Time'],
      xLabels: "day",
      postUnits: "ms",
      lineWidth: 1,
      lineColors: ["#5da423"]
    });
  }
};